import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    paddingLeft: 10,
    flexShrink: 0,
  },
}));